const question = {
  QUESTION_ADD_NEW_ACTION: 'Crear nueva pregunta',
  QUESTION_POPCONFIRM_DELETE_TITLE: '¿Estás seguro que deseas eliminar esta pregunta?',
  QUESTION_MESSAGE_HELP_TEXT: 'Ingrese # para mencionar etiquetas.',
}

export default question
